export enum CorporateContactForms {
  CreateOrEdit = 'CreateOrEditCorporateContact',
  Remove = 'RemoveCorporateContact',
}
